function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('mobx')) : typeof define === 'function' && define.amd ? define(['exports', 'mobx'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.WorkOrderIssueDescriptors = {}, global.mobx));
})(this, function (exports, mobx) {
  'use strict';

  (function (Urgency) {
    Urgency["EMERGENCY"] = "EMERGENCY";
    Urgency["NORMAL"] = "NORMAL";
  })(exports.Urgency || (exports.Urgency = {}));

  (function (OutcomeType) {
    OutcomeType["URGENCY"] = "URGENCY";
    OutcomeType["VENDOR"] = "VENDOR";
  })(exports.OutcomeType || (exports.OutcomeType = {})); //type guard


  function isDescriptor(maybeDescriptor) {
    return !!maybeDescriptor.id;
  }
  /*eslint key-spacing: [2, { "align": "colon", "beforeColon": false, "afterColon": true }]*/
  // Manual mapping
  // Keys map to item__symptom__detail from issue_descriptor in property
  // Values map to issue id in `IssueStore.js`
  // prettier-ignore


  var issueDescriptorsMappings = {
    air_conditioning__none__none: 1,
    air_conditioning__leak__none: 1,
    bathtub__cracked_or_peeling__none: 24,
    bathtub__leak__none: 14,
    breaker__none__none: 4,
    carbon_monoxide_sensor__none__none: 19,
    carpet__none__none: 24,
    ceiling__cracked_or_peeling__none: 24,
    ceiling__leak__none: 14,
    closet_rod__none__none: 24,
    countertops__none__none: 24,
    deck__none__none: 24,
    dishwasher__none__none: 2,
    door__none__none: 24,
    doorbell__none__none: 24,
    drain__clogged__none: 3,
    drain__none__none: 3,
    driveway__none__none: 24,
    dryer__none__none: 2,
    electricity__none__none: 4,
    elevator__none__none: 24,
    fan__none__none: 24,
    faucet__leak__none: 14,
    faucet__none__none: 14,
    fence__none__none: 5,
    filter__none__none: 1,
    fire__none__none: 24,
    fireplace__none__none: 24,
    flooding__none__none: 14,
    freezer__none__none: 2,
    fridge__none__none: 2,
    fridge__leak__none: 2,
    furniture__none__none: 24,
    garage_door__none__none: 8,
    garage_door_keys__locked_out__none: 8,
    garbage_disposal__none__none: 2,
    gas_leak__none__none: 24,
    general_leak__none__none: 14,
    hard_floors__none__none: 24,
    heater__none__none: 9,
    internet__none__none: 24,
    keys_access__locked_out__none: 6,
    landscaping__none__none: 12,
    lights__none__none: 13,
    mailbox__none__none: 24,
    mailbox__locked_out__none: 6,
    microwave__none__none: 2,
    miscellaneous__none__none: 24,
    mold_moisture_mildew__none__none: 24,
    not_maintenance_related__none__none: 24,
    odor__gas_smell__none: 24,
    odor__other_odor__none: 24,
    outlet__none__none: 4,
    oven__none__none: 2,
    paint__none__none: 24,
    pavement__none__none: 24,
    pipes__clogged__none: 3,
    pipes__leak__none: 14,
    pipes__none__none: 3,
    pool__none__none: 24,
    rain_gutters__none__none: 15,
    roof__leak__none: 17,
    roof__missing_shingles__none: 18,
    screens__none__none: 24,
    sewer__none__none: 24,
    shower__cracked_or_peeling__none: 24,
    shower__leak__none: 14,
    shower_glass__none__none: 24,
    shower_head__none__none: 24,
    sink__cracked_or_peeling__none: 24,
    sink__leak__none: 14,
    smoke_detector__none__none: 19,
    snow_service__none__none: 24,
    sprinklers__none__none: 12,
    stove__none__none: 2,
    sump_pump__none__none: 24,
    thermostat__none__none: 1,
    toilet__none__none: 21,
    toilet__clogged__none: 21,
    toilet__running_continuously__none: 20,
    toilet_lid__none__none: 24,
    toilet_paper_holder__none__none: 24,
    towel_racks__none__none: 24,
    trash_can__none__none: 22,
    unit__ants__none: 16,
    unit__bed_bugs__none: 16,
    unit__bees__none: 16,
    unit__birds__none: 16,
    unit__cockroaches__none: 16,
    unit__loose_animal__none: 16,
    unit__moles__none: 16,
    unit__rats_or_mice__none: 16,
    unit__spiders__none: 16,
    unit__termites__none: 16,
    unit__wasps__none: 16,
    wall__none__none: 24,
    wall__leak__none: 14,
    washer__none__none: 2,
    water__gross_color__none: 3,
    water__low_water_pressure__none: 23,
    water__no_water__none: 23,
    water_heater__none__none: 11,
    water_hose__none__none: 12,
    water_spigot__none__none: 12,
    window_coverings__none__none: 24,
    windows__none__none: 24,
    // For compatibility
    air_conditioning__broken__none: 1,
    bathtub__cracked__none: 24,
    birds__infestation__none: 16,
    breaker__broken__none: 4,
    cabinet__broken__none: 24,
    carbon_monoxide_sensor__broken__none: 19,
    carpet__broken__none: 24,
    carpet__dirty__none: 24,
    ceiling__broken__none: 24,
    ceiling__collapsed__none: 24,
    ceiling__cracked__none: 24,
    ceiling__water_spots__none: 14,
    closet_door__broken__none: 24,
    closet_rod__broken__none: 24,
    coin_machine__broken__none: 2,
    countertops__broken__none: 24,
    dishwasher__broken__none: 2,
    door__broken__none: 24,
    door__coming_off_hinges__none: 24,
    door__does_not_open_or_close__none: 7,
    door__will_not_lock__none: 7,
    door_frame__broken__none: 24,
    door_handle__broken__none: 7,
    door_handle__loose__none: 24,
    door_locks__broken__none: 7,
    doorbell__broken__none: 24,
    drain__broken__none: 14,
    drain__leak__constant_flow: 14,
    drain__leak__none: 14,
    drain__leak__small_drip: 14,
    drain__rattling__none: 3,
    drawer__broken__none: 24,
    driveway__broken__none: 24,
    dryer__broken__none: 2,
    dumpster__broken__none: 22,
    electricity__broken__none: 4,
    elevator__broken__none: 24,
    fan__broken__none: 24,
    fan__needs_to_be_flipped__none: 24,
    faucet__broken__none: 24,
    faucet__leak__constant_flow: 14,
    faucet__leak__small_drip: 14,
    faucet__no_water__none: 23,
    faucet__rattling__none: 14,
    filter__broken__none: 1,
    fireplace__broken__none: 24,
    freezer__broken__none: 2,
    fridge__broken__none: 2,
    fridge__missing_parts__none: 2,
    furniture__broken__bed: 24,
    furniture__broken__desk: 24,
    furniture__broken__none: 24,
    furniture__broken__table: 24,
    garage_door__broken__none: 8,
    garbage_disposal__broken__none: 2,
    gate__none__none: 5,
    general_leak__none__constant_flow: 14,
    general_leak__none__small_drip: 14,
    hard_floors__broken__none: 24,
    hard_floors__loose__none: 24,
    heater__broken__none: 9,
    hvac__broken__none: 1,
    hvac__none__none: 1,
    insects__infestation__ants: 16,
    insects__infestation__bees: 16,
    insects__infestation__cockroaches: 16,
    insects__infestation__spiders: 16,
    insects__infestation__termites: 16,
    insects__infestation__wasps: 16,
    internet__broken__none: 24,
    light_switch__broken__none: 13,
    lights__broken__none: 13,
    mailbox__broken__none: 24,
    microwave__broken__none: 2,
    outlet__broken__none: 4,
    oven__broken__none: 2,
    pavement__broken__none: 24,
    pipes__leak__constant_flow: 14,
    pipes__leak__small_drip: 14,
    pipes__rattling__none: 3,
    pool__broken__none: 24,
    rain_gutters__broken__none: 15,
    remote__locked_out__none: 8,
    rodents__infestation__moles: 16,
    rodents__infestation__rats_or_mice: 16,
    screens__broken__none: 24,
    screens__dirty__none: 24,
    screens__missing_parts__none: 24,
    septic_tank__broken__none: 24,
    septic_tank__none__none: 24,
    sewer__broken__none: 24,
    shelves__broken__none: 24,
    shower__cracked__none: 24,
    shower__peeling__none: 24,
    shower_faucet__broken__none: 24,
    shower_glass__broken__none: 24,
    shower_head__broken__none: 24,
    sink__cracked__none: 24,
    sink__peeling__none: 24,
    sliding_doors__broken__none: 24,
    smoke_detector__broken__none: 19,
    sprinklers__broken__none: 12,
    stove__broken__none: 2,
    sump_pump__broken__none: 24,
    thermostat__broken__none: 1,
    tile__broken__none: 24,
    toilet__broken__none: 21,
    toilet__clogged__chain_not_working: 21,
    toilet__clogged__tank_not_filling: 21,
    toilet_lid__broken__none: 24,
    toilet_paper_holder__broken__none: 24,
    towel_racks__broken__none: 24,
    trash_can__broken__none: 22,
    vent__broken__none: 1,
    wall__broken__none: 24,
    wall__water_spots__none: 14,
    washer__broken__none: 2,
    water__odor__none: 3,
    water_heater__broken__none: 11,
    water_heater__water_temperature__none: 11,
    water_hose__broken__none: 12,
    water_shut_off_valve__broken__none: 14,
    water_spigot__broken__none: 12,
    window_coverings__broken__none: 24,
    windows__broken__none: 24,
    windows__dirty__none: 24,
    windows__does_not_open_or_close__none: 24,
    windows__missing_parts__none: 24,
    wire__broken__none: 4
  }; // prettier-ignore

  var synonyms = {
    dishwasher: ['dish washer', 'dishwashing machine'],
    fridge: ['refrigerator', 'refrigeration'],
    freezer: ['cold storage box', 'cooler'],
    microwave: ['microwave oven', 'micro wave oven', 'micro wave'],
    oven: ['gas oven', 'broiler', 'roaster', 'tandoor', 'range'],
    stove: ['cooker', 'stove top', 'burner', 'stove coil', 'stovetop'],
    coin_machine: ['coin operated', 'coin operated machine', 'currency machine'],
    dryer: ['washer/dryer', 'tumble dryer', 'drier', 'laundry'],
    washer: ['washing machine', 'washer/dryer', 'laundry', 'washing'],
    bathtub: ['tub', 'bath', 'whirlpool bath'],
    shower: ['shower head', 'shower hose', 'shower attachment'],
    sink: ['lavatory', 'bathroom sink', 'basin'],
    fan: ['air mover', 'windmill', 'ventilating fan', 'ventilator', 'ceiling fan'],
    shower_glass: ['glass door'],
    tile: ['slate', 'brick', 'backsplash'],
    toilet_lid: ['toilet seat'],
    towel_racks: ['hanger', 'rack'],
    sliding_doors: ['glass door'],
    grout: ['mortar', 'plaster'],
    toilet_paper_holder: [],
    cabinet: ['cupboard', 'hutch'],
    drawer: [],
    shelves: ['shelf', 'mantleshelf', 'bookshelf', 'shelving', 'mantelpiece'],
    ceiling: ['roof'],
    wall: ['partition'],
    closet_door: [],
    closet_rod: ['rod'],
    countertops: ['counter', 'counter top'],
    door_knob: [],
    door_handle: ['lever', 'latch'],
    door_locks: ['lock', 'deadbolt', 'dead bolt'],
    breaker: ['circuit breaker', 'fuse', 'trip switch'],
    ceiling_fan: ['air mover', 'windmill'],
    carbon_monoxide_sensor: ['carbon monoxide detector', 'co detector', 'co sensor'],
    doorbell: ['door bell', 'dinger', 'buzzer'],
    buzzer: [],
    call_box: ['telephone box'],
    electricity: ['power', 'energy', 'electrical'],
    elevator: [],
    garage_door: [],
    lights: ['bulb', 'lightbulb'],
    light_switch: ['switch'],
    outlet: ['wall plug', 'plug', 'power plug', 'wall socket', 'electric receptacle'],
    smoke_detector: ['smoke alarm', 'fire alarm', 'fire detector', 'emergency alarm', 'danger signal'],
    wire: ['cable', 'line'],
    driveway: ['private drive'],
    dumpster: ['trash can', 'trash', 'trash bin'],
    pavement: ['asphalt', 'road', 'sidewalk', 'concrete', 'tar'],
    trash_can: ['garbage pail', 'litter basket', 'dustbin', 'trash bin', 'wastebasket', 'wastebin'],
    landscaping: ['plants', 'grass', 'mow', 'sprinklers', 'gardener', 'gardening'],
    balcony: ['mezzanine', 'terrace'],
    deck: ['porch'],
    porch: ['front porch', 'foyer', 'anteroom', 'stoop', 'lobby'],
    mailbox: ['mail', 'letter drop', 'letterbox', 'mail drop', 'postbox'],
    pool: ['swimming'],
    fence: ['railing', 'partition', 'rail', 'gate'],
    spa: ['hot tub', 'sauna', 'whirlpool'],
    gate: ['lychgate', 'wicket'],
    siding: [],
    stucco: ['plaster'],
    trim: ['sill'],
    door_frame: ['door hinge', 'doorjamb', 'jamb', 'doorway', 'door jam', 'crossbar'],
    sprinklers: ['lawn sprinkler', 'sprinkler head', 'automatic sprinkler', 'fire extinguishing system'],
    sump_pump: ['suction pump'],
    water_hose: ['garden hose', 'hose'],
    water_spigot: ['nozzle', 'valve', 'spout', 'tap'],
    fire: ['burn', 'smoke', 'smoking', 'singed', 'blaze'],
    fireplace: ['fire pit', 'chimney', 'furnace'],
    carpet: ['rug'],
    hard_floors: ['hardwood', 'tile'],
    foundation: ['substructure', 'bottom'],
    gas_leak: [],
    odor: ['smell'],
    gym_equipment: ['workout', 'athletic', 'exercise'],
    air_conditioning: ['ac', 'a/c', 'air cooling', 'central air', 'c/a', 'climate control'],
    hvac: ['central air', 'central ac', 'central heat', 'climate control', 'furnace'],
    air_ducts: ['air pipe', 'air tube'],
    filter: ['ac filter'],
    vent: ['outlet', 'opening'],
    heater: ['radiator', 'convector', 'warmer', 'heat'],
    thermostat: [],
    internet: ['wifi', 'ethernet', 'cable'],
    keys_access: ['keys'],
    garage_door_keys: ['garage door remote'],
    remote: ['clicker'],
    mold_moisture_mildew: ['mold', 'moisture', 'mildew', 'substance', 'damp'],
    paint: [],
    paint_drywall: ['drywall', 'paint'],
    rodents: ['vermin', 'rabbit', 'gnawer', 'gnawing', 'pest', 'burrow', 'nest'],
    insects: ['bugs', 'fly', 'tick', 'pest'],
    drain: [],
    pipes: ['tube', 'piping'],
    faucet: ['nozzle', 'valve', 'spout', 'tap', 'bibb', 'bibcock', 'stopcock', 'spigot'],
    general_leak: ['leaking'],
    flooding: ['inundation', 'swamping', 'gush', 'gushing', 'flood'],
    garbage_disposal: ['compactor', 'garbage disposer', 'garbage grinder'],
    septic_tank: ['sewer', 'septic system', 'sewage disposal tank'],
    sewer: ['sewage'],
    toilet: ['lavatory', 'urinal', 'latrine', 'john', 'loo', 'potty', 'toilette', 'crapper', 'outhouse', 'water closet'],
    water: ['no water'],
    water_filter: [],
    water_shut_off_valve: [],
    water_heater: ['no hot water', 'hot water heater', 'hot water tank', 'cold', 'hot'],
    roof: ['bonnet'],
    rain_gutters: ['gutters'],
    snow_service: ['ice', 'snowplough', 'snowblower', 'snow clearance', 'plow', 'plough'],
    windows: [],
    screens: ['screen door', 'mesh'],
    window_coverings: ['blinds', 'curtain', 'screens'],
    not_maintenance_related: [],
    miscellaneous: [],
    broken: ['not working', 'not functional', 'shattered'],
    missing_parts: [],
    leak: ['leaking'],
    peeling: ['needs paint', 'paint chipping', 'paint chipped', 'flaking', 'recaulk'],
    unit: ['apartment', 'property'],
    needs_paint: [],
    resealing: [],
    fiberglass_issue: [],
    damaged: ['dented'],
    water_spots: ['ceiling leaking'],
    collapsed: [],
    crack: [],
    wrong_direction: ['flip', 'flipped'],
    needs_install: ['installation'],
    wont_turn_on: ['off'],
    needs_cleaning: ['dirty', 'nasty', 'filthy'],
    holes: [],
    coming_loose: ['wiggle', 'jiggle', 'jingle'],
    bulging: ['bump', 'swollen', 'swell'],
    gas_smell: ['sulfur', 'rotten eggs'],
    other_odor: [],
    locked_out: [],
    needs_painting: [],
    not_draining: [],
    part_damaged: [],
    no_water: [],
    ringing_rattling: [],
    running_continuously: ['toilet running'],
    wont_flush: [],
    gross_color: ['brown', 'black'],
    missing_shingles: [],
    does_not_open_or_close: [],
    painted_shut: [],
    need_locks: ['unlocked'],
    needs_retrimming: [],
    needs_removal: [],
    need_screens: [],
    rats_or_mice: ['mice', 'rats', 'rodents', 'mouse'],
    moles: ['gopher', 'gofer', 'burrow'],
    bees: ['hives'],
    ants: ['red ants'],
    wasps: ['hornets'],
    spiders: ['widow', 'recluse', 'tarantula'],
    cockroaches: ['roach'],
    loose_animal: ['possum', 'raccoon', 'bat', 'squirrel', 'animal', 'wildlife']
  };

  var __spreadArrays = undefined && undefined.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  };

  var EXACT_MATCHES_WEIGHT = 100;
  var CLOSE_MATCHES_WEIGHT = 10;
  var FAR_MATCHES_WEIGHT = 1; // prettier-ignore

  var FILTERED_TERMS = new Set(['the', 'be', 'to', 'of', 'and', 'a', 'in', 'that', 'have', 'i', 'it', 'for', 'not', 'on', 'with', 'he', 'as', 'you', 'do', 'at', 'this', 'but', 'his', 'by', 'from', 'they', 'we', 'say', 'her', 'she', 'or', 'an', 'will', 'my', 'one', 'all', 'would', 'there', 'their', 'what', 'is', 'was', 'are', 'have', 'had', 'were', 'can', 'am', 'been', 'being', 'needs', 'needs to', 'to be', 'needs to be', 'no', 'wont']);

  function withoutCommonTerms(words) {
    return words.filter(function (word) {
      return !FILTERED_TERMS.has(word);
    });
  }

  function combineTokens(tokens) {
    return tokens.join(' ');
  }

  function makeCombinations(tokens, size) {
    var combinations = [];

    for (var i = 0; i + size < tokens.length + 1; i += 1) {
      combinations.push(combineTokens(tokens.slice(i, i + size)));
    }

    return combinations.filter(function (s) {
      return s !== '';
    });
  } // slightly modified from https://gist.github.com/andrei-m/982927#gistcomment-1797205


  function levenshteinDistance(a, b, max) {
    var m = [];
    var i;
    var j;
    if (!(a && b)) return (b || a).length;

    if (Math.abs(a.length - b.length) > max) {
      return max + 1;
    }

    for (i = 0; i <= b.length; i += 1) {
      m[i] = [i];
    }

    for (j = 0; j <= a.length; j += 1) {
      m[0][j] = j;
    }

    for (i = 1; i <= b.length; i += 1) {
      var escapeEarly = true;

      for (j = 1; j <= a.length; j += 1) {
        m[i][j] = b.charAt(i - 1) === a.charAt(j - 1) ? m[i - 1][j - 1] : m[i][j] = Math.min(m[i - 1][j - 1] + 1, Math.min(m[i][j - 1] + 1, m[i - 1][j] + 1));

        if (m[i][j] <= max) {
          escapeEarly = false;
        }
      }

      if (escapeEarly) {
        return max + 1;
      }
    }

    return m[b.length][a.length];
  }

  function computeScore(termsToMatch, searchWords) {
    var MAX_LEVENSHTEIN_DISTANCE = 2;
    var levenshteinDistances = searchWords.map(function (word) {
      return Math.min.apply(Math, termsToMatch.map(function (term) {
        return levenshteinDistance(term, word, MAX_LEVENSHTEIN_DISTANCE);
      }));
    });
    var exactMatches = levenshteinDistances.filter(function (d) {
      return d === 0;
    }).length;
    var closeMatches = levenshteinDistances.filter(function (d) {
      return d === 1;
    }).length;
    var farMatches = levenshteinDistances.filter(function (d) {
      return d === 2;
    }).length;
    return exactMatches * EXACT_MATCHES_WEIGHT + closeMatches * CLOSE_MATCHES_WEIGHT + farMatches * FAR_MATCHES_WEIGHT;
  }

  function computeSearchWords(query) {
    if (!query) {
      return [];
    }

    var oneWordTokens = query.split(' ').filter(function (t) {
      return t !== '';
    });
    return withoutCommonTerms(__spreadArrays(oneWordTokens, makeCombinations(oneWordTokens, 2), makeCombinations(oneWordTokens, 3)));
  }

  function getAllTerms(descriptor) {
    var terms = [descriptor.attributes.item, descriptor.attributes.symptom, descriptor.attributes.detail];
    var synonymTerms = terms.map(function (word) {
      return synonyms[word] || [];
    }).reduce(function (acc, v) {
      return acc.concat(v);
    }, []);

    var nonUniqueExpandedTerms = __spreadArrays(terms, synonymTerms).map(function (word) {
      var oneWordTokens = word.toLowerCase().split('_');
      return __spreadArrays(oneWordTokens, makeCombinations(oneWordTokens, 2), makeCombinations(oneWordTokens, 3));
    }).reduce(function (acc, v) {
      return acc.concat(v);
    }, []);

    var uniqueExpandedTerms = Array.from(new Set(nonUniqueExpandedTerms));
    return withoutCommonTerms(uniqueExpandedTerms);
  }

  function searchScores(query, issueDescriptors) {
    var searchWords = computeSearchWords(query);
    return issueDescriptors.map(function (descriptor) {
      return {
        descriptor: descriptor,
        score: computeScore(getAllTerms(descriptor), searchWords)
      };
    });
  }

  function results(query, issueDescriptors) {
    var scores = searchScores(query, issueDescriptors);
    return scores.sort(function (a, b) {
      return b.score - a.score;
    });
  }

  function search(query, issueDescriptors) {
    var formattedQuery = query ? query.toLowerCase().replace(/[^a-z/]/gi, ' ') : null;
    return results(formattedQuery, issueDescriptors).slice(0, 5).filter(function (score) {
      return score.score > 0;
    }).map(function (score) {
      return score.descriptor;
    });
  }
  /* eslint-disable max-len */


  var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
      if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  };

  var __spreadArrays$1 = undefined && undefined.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  };

  var IssueDescriptorStore =
  /** @class */
  function () {
    function IssueDescriptorStore() {
      this.search = '';
      this.issueDescriptorsLoadSuccess = false;
      this.allDescriptors = mobx.observable.array();
      this.searchResults = mobx.observable.array();
      this.descriptorSelected = {};
      this.descriptorSelectedBubbleIndex = null;
      this.otherIsSelected = false;
      this.searchAtTimeOfSelection = '';
      this.SEARCH_TIMEOUT = 1000;
      this.searchTimedOut = false;
    }

    IssueDescriptorStore.prototype.submitSearch = function (search$1, searchFunction) {
      if (searchFunction === void 0) {
        searchFunction = search;
      }

      this.search = search$1;
      if (this.searchTimedOut) return;
      this.updateSearchTimeout(this.search);
      this.searchResults.replace(searchFunction(search$1, this.allDescriptors.slice()));
    };

    IssueDescriptorStore.prototype.updateSearchTimeout = function (mostRecentSearch, timeout) {
      var _this = this;

      if (timeout === void 0) {
        timeout = this.SEARCH_TIMEOUT;
      }

      this.searchTimedOut = true;
      setTimeout(function () {
        mobx.runInAction(function () {
          _this.searchTimedOut = false;
          if (mostRecentSearch !== _this.search) _this.submitSearch(_this.search);
        });
      }, timeout);
    };

    Object.defineProperty(IssueDescriptorStore.prototype, "issueDescriptorName", {
      get: function get() {
        if (isDescriptor(this.descriptorSelected)) {
          return this.descriptorSelected.attributes.item + "__" + this.descriptorSelected.attributes.symptom + "__" + this.descriptorSelected.attributes.detail;
        }

        return '';
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(IssueDescriptorStore.prototype, "classicId", {
      get: function get() {
        if (isDescriptor(this.descriptorSelected) && this.allDescriptors.length > 0) {
          var mapped = issueDescriptorsMappings[this.issueDescriptorName];
          if (!mapped) return '';
          return mapped.toString();
        }

        return '';
      },
      enumerable: false,
      configurable: true
    });

    IssueDescriptorStore.prototype.fetchIssueDescriptors = function (fetchFunction) {
      var _this = this;

      return fetchFunction().then(function (result) {
        _this.allDescriptors.replace(result.descriptors);

        _this.issueDescriptorsLoadSuccess = true;
        return result;
      }).catch(function () {
        _this.issueDescriptorsLoadSuccess = false;
      });
    };

    IssueDescriptorStore.prototype.setSelected = function (descriptorId, otherIsSelected, bubbleIndex) {
      if (bubbleIndex === void 0) {
        bubbleIndex = null;
      }

      if (descriptorId !== this.descriptorSelected.id || this.otherIsSelected !== otherIsSelected) {
        this.descriptorSelected = this.allDescriptors.find(function (desc) {
          return desc.id === descriptorId;
        }) || {};
        this.descriptorSelectedBubbleIndex = bubbleIndex;
        this.searchAtTimeOfSelection = this.search;
      } else {
        this.descriptorSelected = {};
        this.descriptorSelectedBubbleIndex = null;
        this.searchAtTimeOfSelection = '';
      }

      this.otherIsSelected = otherIsSelected;
    };

    IssueDescriptorStore.prototype.setOtherIsSelected = function () {
      this.descriptorSelected = {};
      this.descriptorSelectedBubbleIndex = null;
      this.otherIsSelected = !this.otherIsSelected;
    };

    Object.defineProperty(IssueDescriptorStore.prototype, "bubbleDescriptors", {
      get: function get() {
        var _this = this;

        var results = __spreadArrays$1(this.searchResults);

        if (isDescriptor(this.descriptorSelected) && !results.some(function (res) {
          return res.id === _this.descriptorSelected.id;
        }) && !this.otherIsSelected) {
          results.push(this.descriptorSelected);
        }

        return results;
      },
      enumerable: false,
      configurable: true
    });

    IssueDescriptorStore.prototype.reloadDescriptor = function (descriptorId, search) {
      if (descriptorId === void 0) {
        descriptorId = '';
      }

      if (search === void 0) {
        search = '';
      }

      this.search = '';
      this.searchResults.clear();
      this.descriptorSelected = {};
      this.otherIsSelected = false;

      if (descriptorId) {
        this.descriptorSelected = this.allDescriptors.find(function (desc) {
          return desc.id === descriptorId;
        }) || {};
      }

      if (search) {
        this.submitSearch(search);
      }
    };

    IssueDescriptorStore.prototype.getMccIssueTypeByIssueDescriptorUuid = function (id) {
      var issueDescriptor = this.allDescriptors.find(function (desc) {
        return desc.id === id;
      });
      if (issueDescriptor === undefined) return null;
      return issueDescriptorsMappings[issueDescriptor.attributes.item + "__" + issueDescriptor.attributes.symptom + "__" + issueDescriptor.attributes.detail];
    };

    __decorate([mobx.observable], IssueDescriptorStore.prototype, "search", void 0);

    __decorate([mobx.observable], IssueDescriptorStore.prototype, "issueDescriptorsLoadSuccess", void 0);

    __decorate([mobx.observable], IssueDescriptorStore.prototype, "descriptorSelected", void 0);

    __decorate([mobx.observable], IssueDescriptorStore.prototype, "descriptorSelectedBubbleIndex", void 0);

    __decorate([mobx.observable], IssueDescriptorStore.prototype, "otherIsSelected", void 0);

    __decorate([mobx.observable], IssueDescriptorStore.prototype, "searchAtTimeOfSelection", void 0);

    __decorate([mobx.observable], IssueDescriptorStore.prototype, "searchTimedOut", void 0);

    __decorate([mobx.action], IssueDescriptorStore.prototype, "submitSearch", null);

    __decorate([mobx.action], IssueDescriptorStore.prototype, "updateSearchTimeout", null);

    __decorate([mobx.computed], IssueDescriptorStore.prototype, "issueDescriptorName", null);

    __decorate([mobx.computed], IssueDescriptorStore.prototype, "classicId", null);

    __decorate([mobx.action], IssueDescriptorStore.prototype, "fetchIssueDescriptors", null);

    __decorate([mobx.action], IssueDescriptorStore.prototype, "setSelected", null);

    __decorate([mobx.action], IssueDescriptorStore.prototype, "setOtherIsSelected", null);

    __decorate([mobx.computed], IssueDescriptorStore.prototype, "bubbleDescriptors", null);

    __decorate([mobx.action], IssueDescriptorStore.prototype, "reloadDescriptor", null);

    return IssueDescriptorStore;
  }();

  var __decorate$1 = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
      if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  };

  var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }

    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };

  var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
        f,
        y,
        t,
        g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;

    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }

    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");

      while (_) {
        try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];

          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;

            case 4:
              _.label++;
              return {
                value: op[1],
                done: false
              };

            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;

            case 7:
              op = _.ops.pop();

              _.trys.pop();

              continue;

            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }

              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }

              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }

              if (t && _.label < t[2]) {
                _.label = t[2];

                _.ops.push(op);

                break;
              }

              if (t[2]) _.ops.pop();

              _.trys.pop();

              continue;
          }

          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      }

      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  };

  var MaintenanceRulesStore =
  /** @class */
  function () {
    function MaintenanceRulesStore(rulesDecisionsApi, issueDescriptorStore) {
      if (issueDescriptorStore === void 0) {
        issueDescriptorStore = new IssueDescriptorStore();
      }

      this.rulesDecisionsApi = rulesDecisionsApi;
      this.issueDescriptorStore = issueDescriptorStore;
      this.triageDetails = mobx.observable.array();
      this.preferredVendors = mobx.observable.array();
      this.rulesDecisionPending = false;
      this.unitId = '';
      this.occupancyId = '';
      this.rulesDecisionOverrides = {};
    }

    MaintenanceRulesStore.prototype.reloadDescriptor = function (issueDescriptorId, search) {
      return this.issueDescriptorStore.reloadDescriptor(issueDescriptorId, search);
    };

    MaintenanceRulesStore.prototype.updateInputs = function (_a) {
      var workOrderId = _a.workOrderId,
          issueDescriptorId = _a.issueDescriptorId,
          otherIsSelected = _a.otherIsSelected,
          bubbleIndex = _a.bubbleIndex,
          vhost = _a.vhost;
      var descriptorUpdated = issueDescriptorId !== this.issueDescriptorStore.descriptorSelected.id;
      this.triageDetails.clear();

      if (workOrderId) {
        this.workOrderId = workOrderId;
      } else {
        this.issueDescriptorStore.setSelected(issueDescriptorId, otherIsSelected !== null && otherIsSelected !== void 0 ? otherIsSelected : false, bubbleIndex);
      }

      if (vhost && vhost !== this.vhost) {
        this.vhost = vhost;
      }
    };

    MaintenanceRulesStore.prototype.getRulesDecision = function (outcomeType) {
      return __awaiter(this, void 0, void 0, function () {
        var exactlyOne, _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              exactlyOne = Boolean(this.descriptorSelected.id) !== Boolean(this.workOrderId);

              if (!exactlyOne) {
                return [2
                /*return*/
                ];
              }

              this.rulesDecisionPending = true;
              _b.label = 1;

            case 1:
              _b.trys.push([1,, 7, 8]);

              _a = outcomeType;

              switch (_a) {
                case exports.OutcomeType.URGENCY:
                  return [3
                  /*break*/
                  , 2];

                case exports.OutcomeType.VENDOR:
                  return [3
                  /*break*/
                  , 4];
              }

              return [3
              /*break*/
              , 6];

            case 2:
              return [4
              /*yield*/
              , this.getUrgencyDecision()];

            case 3:
              _b.sent();

              return [3
              /*break*/
              , 6];

            case 4:
              return [4
              /*yield*/
              , this.getVendorsDecision()];

            case 5:
              _b.sent();

              return [3
              /*break*/
              , 6];

            case 6:
              return [3
              /*break*/
              , 8];

            case 7:
              this.rulesDecisionPending = false;
              return [7
              /*endfinally*/
              ];

            case 8:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    MaintenanceRulesStore.prototype.getUrgencyDecision = function () {
      return __awaiter(this, void 0, void 0, function () {
        var rulesDecision;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.rulesDecisionsApi.getDecision({
                issueDescriptorId: this.issueDescriptorStore.descriptorSelected.id,
                triageDetails: this.triageDetails,
                workOrderId: this.workOrderId,
                unitId: this.unitId,
                vhost: this.vhost,
                outcomeType: exports.OutcomeType.URGENCY
              })];

            case 1:
              rulesDecision = _a.sent();
              this.rulesDecision = rulesDecision;
              this.triageDetails.replace(this.rulesDecision.triage_details);
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    MaintenanceRulesStore.prototype.getVendorsDecision = function () {
      return __awaiter(this, void 0, void 0, function () {
        var rulesDecision;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.rulesDecisionsApi.getDecision({
                issueDescriptorId: this.issueDescriptorStore.descriptorSelected.id,
                workOrderId: this.workOrderId,
                occupancyId: this.occupancyId,
                vhost: this.vhost,
                outcomeType: exports.OutcomeType.VENDOR
              })];

            case 1:
              rulesDecision = _a.sent();
              this.preferredVendors.replace(rulesDecision.preferredVendors.sort(function (vendor1, vendor2) {
                return vendor1.position - vendor2.position;
              }));
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    MaintenanceRulesStore.prototype.setUnitId = function (id) {
      this.unitId = id;
    };

    MaintenanceRulesStore.prototype.setOccupancyId = function (id) {
      this.occupancyId = id;
    };

    MaintenanceRulesStore.prototype.getMccIssueTypeByIssueDescriptorUuid = function (issueDescriptorUuid) {
      return this.issueDescriptorStore.getMccIssueTypeByIssueDescriptorUuid(issueDescriptorUuid);
    };

    Object.defineProperty(MaintenanceRulesStore.prototype, "loadedRulesDecisionOverrides", {
      get: function get() {
        var _a;

        return (_a = this.rulesDecision) === null || _a === void 0 ? void 0 : _a.overrides;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "descriptorSelectedBubbleIndex", {
      get: function get() {
        return this.issueDescriptorStore.descriptorSelectedBubbleIndex;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "issueDescriptorsLoadSuccess", {
      get: function get() {
        return this.issueDescriptorStore.issueDescriptorsLoadSuccess;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "searchAtTimeOfSelection", {
      get: function get() {
        return this.issueDescriptorStore.searchAtTimeOfSelection;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "descriptorSelected", {
      get: function get() {
        return this.issueDescriptorStore.descriptorSelected;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "otherIsSelected", {
      get: function get() {
        return this.issueDescriptorStore.otherIsSelected;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "bubbleDescriptors", {
      get: function get() {
        return this.issueDescriptorStore.bubbleDescriptors;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "allDescriptors", {
      get: function get() {
        return this.issueDescriptorStore.allDescriptors;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "search", {
      get: function get() {
        return this.issueDescriptorStore.search;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "classicId", {
      get: function get() {
        return this.issueDescriptorStore.classicId;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(MaintenanceRulesStore.prototype, "issueDescriptorName", {
      get: function get() {
        return this.issueDescriptorStore.issueDescriptorName;
      },
      enumerable: false,
      configurable: true
    });

    MaintenanceRulesStore.prototype.setOtherIsSelected = function () {
      return this.issueDescriptorStore.setOtherIsSelected();
    };

    MaintenanceRulesStore.prototype.setTriageDetails = function (triageDetails) {
      this.triageDetails.replace(triageDetails);
    };

    MaintenanceRulesStore.prototype.setRulesDecisionOverrides = function (rulesDecisionOverrides) {
      this.rulesDecisionOverrides = rulesDecisionOverrides;
    };

    MaintenanceRulesStore.prototype.reset = function () {
      this.rulesDecision = null;
      this.triageDetails.clear();
      this.setUrgencyOverride(undefined);
      this.workOrderId = null;
    };

    MaintenanceRulesStore.prototype.setUrgencyOverride = function (value) {
      this.rulesDecisionOverrides = value === undefined ? {} : {
        urgency: value
      };
    };

    MaintenanceRulesStore.prototype.fetchIssueDescriptors = function (fetchFunction) {
      return this.issueDescriptorStore.fetchIssueDescriptors(fetchFunction) // temp workaround till new types are pushed to package
      .then(function (result) {
        return result;
      });
    };

    MaintenanceRulesStore.prototype.submitSearch = function (query) {
      this.issueDescriptorStore.submitSearch(query);
    };

    __decorate$1([mobx.observable], MaintenanceRulesStore.prototype, "rulesDecisionPending", void 0);

    __decorate$1([mobx.observable], MaintenanceRulesStore.prototype, "rulesDecision", void 0);

    __decorate$1([mobx.observable], MaintenanceRulesStore.prototype, "rulesDecisionOverrides", void 0);

    __decorate$1([mobx.observable], MaintenanceRulesStore.prototype, "workOrderId", void 0);

    __decorate$1([mobx.observable], MaintenanceRulesStore.prototype, "vhost", void 0);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "reloadDescriptor", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "updateInputs", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "getRulesDecision", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "getUrgencyDecision", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "getVendorsDecision", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "setUnitId", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "setOccupancyId", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "loadedRulesDecisionOverrides", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "descriptorSelectedBubbleIndex", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "issueDescriptorsLoadSuccess", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "searchAtTimeOfSelection", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "descriptorSelected", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "otherIsSelected", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "bubbleDescriptors", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "allDescriptors", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "search", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "classicId", null);

    __decorate$1([mobx.computed], MaintenanceRulesStore.prototype, "issueDescriptorName", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "setOtherIsSelected", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "setTriageDetails", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "setRulesDecisionOverrides", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "reset", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "setUrgencyOverride", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "fetchIssueDescriptors", null);

    __decorate$1([mobx.action], MaintenanceRulesStore.prototype, "submitSearch", null);

    return MaintenanceRulesStore;
  }();

  exports.MaintenanceRulesStore = MaintenanceRulesStore;
  exports.isDescriptor = isDescriptor;
  exports.issueDescriptorsMappings = issueDescriptorsMappings;
  exports.search = search;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});